import useScrollReveal from '@/hooks/useScrollReveal';
import SectionHeading from '@/components/feature/SectionHeading';

const reasons = [
  {
    label: 'Kava & sprostitev',
    title: 'Začni dan ob pravi kavi.',
    text: 'Nagrajena kava, pripravljena z ljubeznijo. Popoln espresso ali kremast kapučino za miren začetek dneva.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/d236ed575fc43bd6ac8684b12098b545.png',
    imageAlt: 'Skodelica kapučina z srčkom in kozarec vode na pladnju v lokalu Guma Caffe Lounge Bar',
    imageTitle: 'Najboljša kava v Guma Caffe Lounge Bar Gorišnica',
  },
  {
    label: 'Terasa & druženje',
    title: 'Najboljši trenutki so v družbi.',
    text: 'Prostorna pokrita terasa z lesenim pohištvom in prijetno senco — idealna točka za klepet s prijatelji.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/a4a84974d868f72c55958079e5b70b0b.png',
    imageAlt: 'Dve osvežilni pijači z limeto na terasi lokala Guma Caffe Lounge Bar',
    imageTitle: 'Terasa Guma Caffe Lounge Bar Gorišnica – druženje na prostem',
  },
  {
    label: 'Koktejli & večeri',
    title: 'Ko se dan prevesi v noč.',
    text: 'Vikend koktejli, hladno pivo in sproščen večerni ambient. Vsak obisk je razlog za nov spomin.',
    image:
      'https://static.readdy.ai/image/610b801a81a299b5cf2b47908013d228/3a2f1cbe0626d755c2a35083f8b69d12.png',
    imageAlt: 'Dva ledeno hladna zelena koktajla z rezino pomaranče in slamico',
    imageTitle: 'Vikend koktejli v Guma Caffe Lounge Bar Zamušani',
  },
];

export default function ReasonsSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <section id="razlogi" className="relative py-16 md:py-24 px-4 md:px-6 bg-background-100 scroll-mt-16 md:scroll-mt-20" ref={ref}>
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <SectionHeading
          eyebrow="Izberi svoj trenutek"
          title="Trije razlogi za obisk"
          description="Zakaj je Guma Bar prava izbira za tvoj naslednji obisk — preprosto, a iskreno."
        />

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7">
          {reasons.map((reason, idx) => (
            <article
              key={idx}
              className={`group relative overflow-hidden rounded-lg aspect-[4/5] md:aspect-[5/6] cursor-pointer transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${200 + idx * 150}ms` }}
            >
              <img
                src={reason.image}
                alt={reason.imageAlt}
                title={reason.imageTitle}
                className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent transition-opacity duration-500"></div>

              <div className="relative z-10 h-full flex flex-col justify-end p-5 md:p-7">
                <p className="text-[10px] md:text-xs font-semibold tracking-widest uppercase text-accent-300 mb-2">
                  {reason.label}
                </p>
                <h3 className="font-heading text-xl md:text-2xl text-foreground-50 font-light mb-2 drop-shadow-md">
                  {reason.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-50/85 leading-relaxed drop-shadow-sm">
                  {reason.text}
                </p>
              </div>

              <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-accent-500 scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}